import { FC } from 'react';
import styles from './index.module.scss';

/**
 * AI 面试官动态头像组件
 *
 * 实现说明：
 * - 动画由前端渲染，非静态图片
 * - 缓慢、连续的循环动画（6-10 秒）
 * - 动效形式：渐变旋转
 *
 * 状态差异：
 * - idle/listening: 动效非常缓慢、克制（10 秒循环）
 * - talking: 动效略微加快（6 秒循环），提示 AI 正在发言
 *
 * 非交互组件，不支持点击或悬停
 */

export type AIInterviewerAvatarStatus = 'idle' | 'listening' | 'talking';

interface AIInterviewerAvatarProps {
  /** 当前状态，影响动画速度 */
  status?: AIInterviewerAvatarStatus;
  /** 自定义类名 */
  className?: string;
}

const AIInterviewerAvatar: FC<AIInterviewerAvatarProps> = ({ status = 'idle', className }) => {
  return (
    <div className={`${styles.avatar} ${styles[status]} ${className || ''}`}>
      {/* 放射状渐变背景 - 多层叠加增强视觉效果 */}
      <div className={styles.gradientLayer1} />
      <div className={styles.gradientLayer2} />
      <div className={styles.gradientLayer3} />

      {/* 中心光晕效果 */}
      <div className={styles.centerGlow} />
    </div>
  );
};

export default AIInterviewerAvatar;
